export default __webpack_public_path__ + "static/media/henry-co-cp-VMJ-mdKs-unsplash.29396d47.png";